module.exports = __webpack_public_path__ + "img/zw_logo.e71da83a.png";